export interface DistinctCounts {
	coatingSystemCount: number;
	colourCount: number;
	productCount: number;
	suppliersCount: number;
}
